module.exports = __webpack_public_path__ + "static/media/Home_logo_dabeisein.437c1a74.svg";